import { render, staticRenderFns } from "./BeoReport.vue?vue&type=template&id=7fb90811&scoped=true"
import script from "./BeoReport.vue?vue&type=script&lang=ts"
export * from "./BeoReport.vue?vue&type=script&lang=ts"
import style0 from "./BeoReport.vue?vue&type=style&index=0&id=7fb90811&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb90811",
  null
  
)

export default component.exports